import { createAction, props } from "@ngrx/store";
import type { BugReport } from "./bug-report.models";

export const BugReportCreateRequest = createAction(
  '[BugReport] Create Request',
  props<{ payload: FormData }>()
);

export const BugReportFetchRequest = createAction(
  '[BugReport] Fetch Request'
);

export const BugReportFetchSuccess = createAction(
  '[BugReport] Fetch Success',
  props<{ reports: BugReport[] }>()
);

export const BugReportFetchFailure = createAction(
  '[BugReport] Fetch Failure',
  props<{ error: string }>()
);

export const BugReportUpdateStatusRequest = createAction(
  '[BugReport] Update Status Request',
  props<{ id: string; status: 'open' | 'closed' }>()
);

export const BugReportUpdateStatusSuccess = createAction(
  '[BugReport] Update Status Success',
  props<{ report: BugReport }>()
);

export const BugReportUpdateStatusFailure = createAction(
  '[BugReport] Update Status Failure',
  props<{ error: string }>()
);

export const BugReportCreateSuccess = createAction(
  '[BugReport] Create Success',
  props<{ report: BugReport }>()
);

export const BugReportCreateFailure = createAction(
  '[BugReport] Create Failure',
  props<{ error: string }>()
);

export const BugReportClearStatus = createAction(
  '[BugReport] Clear Status'
);
